export const truncateString = (string: string, start: number, end: number) => {
  const length = string.length;

  return `${string.substring(0, start)}...${string.substring(length - end, length)}`;
};
